<template>
	<div>
		<Header :active="3"></Header>
		<div class="banner">
			<img id="id1" class="FadeIn" src="../assets/about/icon/p20.png">
		</div>
		<div class="searchDiv">
			<div class="content flex">
				<div class="position">
					当前位置：
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }">网站首页</el-breadcrumb-item>
						<el-breadcrumb-item>企业介绍</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="screen flex">
					<div @click="active=index" v-scroll-to="'#'+item.Jump" :class="{on:active==index}"
						v-for="(item,index) in Navigation" :key="index">{{item.name}}</div>
				</div>
			</div>
		</div>
		<div id="introduce" class="introduce">
			<div class="content">
				<img class="left" src="../assets/about/icon/p9.png">
				<div class="right">
					<img src="../assets/about/icon/p8.png">
					<p class="p1">
						湖南海润天恒信息科技有限公司成立于2019年，由湖南海纳明人集团和湖南天河国云共同投资，是一家通过区块链技术赋能人力资源服务向智能化、平台化升级的科技公司。公司秉承持续创新的理念，基于区块链、人工智能、大数据、
						云计算、移动互联网等前沿技术为企业提供人力资源全方位服务。</p>
					<p>核心团队来自ADP中国、Randstad、阿里巴巴、腾讯、华为等互联网科技企业，汇聚云计算、大数据、人工智能三大技术领域的人才。</p>
				</div>
			</div>
		</div>
		<div class="Culture">
			<div class="content">
				<div class="list">
					<img src="../assets/about/icon/p12.png">
					<h5>使命</h5>
					<p>MISSION</p>
					<div style="width: 160px;">为用户提升人生价值<br/>为客户创造人力资本<br/>为民族复兴持续奋斗</div>
				</div>
				<div style="margin-left: -45px;" class="list">
					<img src="../assets/about/icon/p17.png">
					<h5>愿景</h5>
					<p>VISION</p>
					<div style="width: 176px;">成为一亿蓝领的职场家园</div>
				</div>
				<div class="list">
					<img src="../assets/about/icon/p5.png">
					<h5>价值观</h5>
					<p>VALUES</p>
					<div style="width: 160px;"> 成就客户，以人为本<br/>公信开放，持续创新</div>
				</div>
			</div>
		</div>
		<div id="hotspot" class="hotspot">
			<div class="content">
				<img class="title" src="../assets/about/icon/p10.png">
			</div>
			<div @mouseover="changeActive()" @mouseout="removeActive()" class="bpttom">
				<div class="content">
					<div class="left">
						<template v-for="(item,index) in hotspotList">
							<div v-if="hotspotOn==index" :key="index" class="list">
								<a :target="item.url?'_blank':'_self'" :href="item.url?item.url:'javascript:;'">
									<div class="time FadeIn">{{item.time}}</div>
									<h4 class="FadeIn">{{item.name}}</h4>
									<p class="FadeIn">{{item.text}}</p>
									<div v-if="item.url" class="more FadeIn">
										<span>More</span>
										<div class="img"></div>
									</div>
								</a>
							</div>
						</template>
						<div class="indicator flex">
							<div @click="hotspotOn = index" :class="{on:hotspotOn==index}" v-for="(item,index) in 6"
								:key="index"></div>
						</div>
					</div>
					<div class="right">
						<img :class="{on:hotspotOn==index2}" v-for="(item,index2) in hotspotList" :key="index2"
							:src="item.img">
					</div>
				</div>
			</div>
		</div>
		<div id="work" class="work">
			<div class="content">
				<div class="title"></div>
				<el-carousel trigger="click" height="364px" @change="carousel" indicator-position="none" arrow="always"
					:interval="5000">
					<el-carousel-item>
						<div class="list flex">
							<div>
								<img src="../assets/about/License/p1.png">
								<p>HRMS链长结构智能分配系统V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p2.png">
								<p>企业员工智能入职流程管理系统V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p3.png">
								<p>企业招聘客服服务中心系统V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p4.png">
								<p>企业招聘赏金智能结算系统V1.0</p>
							</div>
						</div>
					</el-carousel-item>
					<el-carousel-item>
						<div class="list flex">
							<div>
								<img src="../assets/about/License/p5.png">
								<p>上职家HRMS客户资源V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p6.png">
								<p>上职家平台组织架构信息V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p7.png">
								<p>上职家企业人才数据库V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p8.png">
								<p>上职家企业员工入职福利V1.0</p>
							</div>
						</div>
					</el-carousel-item>
					<el-carousel-item>
						<div class="list flex">
							<div>
								<img src="../assets/about/License/p9.png">
								<p>上职家企业员工招聘佣金对象V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p10.png">
								<p>上职家企业员工智能离职V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p11.png">
								<p>上职家企业员工智能薪酬V1.0</p>
							</div>
							<div>
								<img src="../assets/about/License/p12.png">
								<p>上职家企业智能保险信息V1.0</p>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<div id="contact" class="contact">
			<div class="content">
				<img class="left" src="../assets/about/icon/p3.png">
				<div class="right">
					<div class="title"></div>
					<div class="list">
						<img src="../assets/about/icon/p2.png">
						电话: 400-162-5566
					</div>
					<div class="list">
						<img src="../assets/about/icon/p1.png">
						地址: 湖南省长沙经开区东六路科技新城C2栋15楼
					</div>
					<div class="list">
						<img src="../assets/about/icon/p14.png">
						邮箱: shang_zhijia@163.com
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../components/subHead.vue'
	export default {
		name: "aboutUs",
		components: {
			Header
		},
		metaInfo: {
			title: '关于我们'
		},
		data() {
			return {
				styleList: [1],
				Navigation: [
					{
						name:'企业介绍',
						Jump:'introduce'
					},
					{
						name:'企业热点',
						Jump:'hotspot'
					},
					{
						name:'软件著作',
						Jump:'work'
					},
					{
						name:'联系我们',
						Jump:'contact'
					},
				],
				active: 0,
				hotspotList: [{
						name: '开展承恩落地师友互助交流会',
						time: '04-16',
						text: '菲纹集团刘备德，三毛摄影董事长孙吉鲁、总经理江兵莅临湖南海润天恒信息科技有限公司开展承恩落地师友互助交流会，会议主要围绕上职家平台的发展战略......',
						img: require('../assets/about/hotspot/p1.png'),
						url:'https://mp.weixin.qq.com/s/fGVWykIIk1yHbI5Y0qwAIA'
					},
					{
						name: '上职家助力企业复工复查',
						time: '10-23',
						text: '基于区块链技术研发的上职家人力资源服务平台为湖南省企业复工复产按下快捷键',
						img: require('../assets/about/hotspot/p2.png'),
						url:''
					},
					{
						name: '董事长向长沙市组织部领导汇报上职家项目',
						time: '10-16',
						text: '长沙市委组织部副部长易敏华、长沙经济技术开发区党工委委员、副书记贺代贵、长沙市人社局等领导一行莅临长沙经济技术开发区人力资源服务产业园走访园区优秀企业，了解疫情防控常态下的人资行业最新动态。在园区领导的陪同下，董事长郭泳辰详细汇报了上职家项目在人力资源行业的创新举措。',
						img: require('../assets/about/hotspot/p3.png'),
						url:'https://mp.weixin.qq.com/s/nG5AgCsBdoGysLm4yF6dRA'
					},
					{
						name: '海润天恒与光大银行正式签署战略合作协议',
						time: '01-13',
						text: '光大银行长沙分行与湖南海润天恒信息科技有限公司在光大银行长沙分行处签署战略合作协议确立了双方在软件金融层面的一系列合作。仪式现场嘉宾有光大银行长沙分行副行长、零售主管行长王亚娜、光大银行长沙分行零售部总经理张颖、光大银行开福支行长钟文辉、海润天恒董事长郭泳辰、海润天恒总经理罗兴、湖南天河国云董事长兼CEO上职家联合创始人谭林、海润天恒技术总监赵荣等人。',
						img: require('../assets/about/hotspot/p4.png'),
						url:'https://mp.weixin.qq.com/s/W5r_9FVCby6w7uPn6OL1FA'
					},
					{
						name: '与招商银行开展合作研讨会',
						time: '01-12',
						text: '海润天恒与招商银行开展多板块、多维度的合作融通，使金融和人力资源行业深度融合，实现互利共赢',
						img: require('../assets/about/hotspot/p5.png'),
						url:''
					},
					{
						name: '邵阳经开区党工委领导一行指导工作',
						time: '01-08',
						text: '上职家不断投入研发力量，重点保障用户个人信息和隐私安全，融通各方优势，打造强强联合、互惠共赢的局面',
						img: require('../assets/about/hotspot/p6.png'),
						url:''
					}
				],
				hotspotOn: 0
			}
		},
		mounted() {
			// console.log(this.$route.path);
			window.addEventListener('scroll', this.scrollToTop);
			this.timer = setInterval(() => {
				this.BannerSwitch();
			}, 5000);
		},
		beforeDestroy() {
			console.log('销毁');
			window.removeEventListener('scroll', this.scrollToTop);
			clearInterval(this.timer);
		},
		methods: {
			/**
			 * 鼠标滑出
			 */
			removeActive(){
				this.timer = setInterval(() => {
					this.BannerSwitch();
				}, 5000);
			},
			/**
			 * 鼠标滑入
			 */
			changeActive(){
				clearInterval(this.timer);
			},
			carousel(i) {
				// console.log(i, '轮播图索引');
				this.bannerOn = i;
			},
			BannerSwitch() {
				if (this.hotspotOn < 5) {
					this.hotspotOn++;
				} else {
					this.hotspotOn = 0;
				}
			},
			scrollToTop() {
				// 获取视窗高度
				var domHight = document.documentElement.clientHeight;
				// dom滚动位置
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// 获取监听元素
				var id;
				// 获取监听元素本身高度
				var scrollHeight;
				// 获取监听元素距离视窗顶部距离
				var offsetTop;
				// 获取监听元素距离顶部高度-窗口高度 
				var top;
				// 元素距离底部的高度+元素本身高度
				var bottom;
				if (this.styleList.length > 0) {
					this.styleList.map((i) => {
						id = document.getElementById(`id${i}`);
						scrollHeight = id.scrollHeight;
						offsetTop = id.offsetTop;
						top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
						bottom = scrollHeight + offsetTop;
						// 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
						console.log(scrollHeight, offsetTop, domHight, scrollTop, top, bottom);
						if (scrollTop >= top && scrollTop <= bottom) {
							console.log('元素出现在可视区: ' + i);
							id.classList.add("FadeIn");
						} else {
							console.log('元素不在了: ' + i);
							id.classList.remove("FadeIn");
						}
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.contact {
		.right {
			.list:before {
				content: "";
				display: block;
				position: absolute;
				bottom: -1px;
				left: 0;
				width: 80px;
				height: 1px;
				background: #00BCD4;
			}

			.list {
				img {
					width: 30px;
					height: 30px;
					margin-right: 13px;
				}

				font-size: 16px;
				color: #333333;
				display: flex;
				align-items: center;
				padding: 30px 0;
				border-bottom: 1px solid #F8F8F8;
				position: relative;
			}

			.title {
				width: 230px;
				height: 66px;
				background: url(../assets/about/icon/p7.png)no-repeat;
				background-size: cover;
				margin-bottom: 10px;
			}
		}

		.left {
			width: 600px;
			height: 400px;
			margin-right: 40px;
		}

		.content {
			display: flex;
		}

		margin-bottom: 80px;
	}

	/deep/.el-carousel__arrow:hover {
		border: 1px solid #00BCD4;
		color: #00BCD4 !important;
	}

	/deep/.el-carousel__arrow {
		border-radius: 0 !important;
		border: 1px solid #999999;
		color: #999999 !important;
		background-color: rgb(31 45 61 / 0%) !important;
		top: 44%;
	}

	.work {
		.list {
			img {
				width: 235px;
				height: 320px;
				margin-bottom: 26px;
			}

			font-size: 14px;
			color: #666666;
			width: 1022px;
			margin: auto;
			text-align: center;
		}

		.title {
			width: 160px;
			height: 56px;
			margin: 0 auto 40px;
			background: url(../assets/about/icon/p11.png)no-repeat;
			background-size: cover;
		}

		padding: 60px 0;
	}

	.hotspot {
		.bpttom {
			.content {
				.right {
					position: relative;
					margin-left: 48px;
					top: -145px;
					background-color: #272727;
					width: 620px;
					height: 435px;

					.on {
						animation: show 3500ms both;
					}

					img {
						width: 620px;
						height: 435px;
						position: absolute;
						opacity: 0;
					}

					@keyframes show {

						to {
							opacity: 1;
						}

						from {
							opacity: 0;
						}
					}
				}

				.left {
					.indicator {
						.on {
							background-color: #00BCD4 !important;
						}

						div:hover {
							background-color: #00bcd433 !important;
						}

						div {
							width: 9px;
							height: 9px;
							background-color: #CCCCCC;
						}

						width: 114px;
						height: 9px;
						float: right;
						margin-top: 45px;
						cursor: pointer;
					}

					.more {
						.img {
							width: 25px;
							height: 10px;
							margin-left: 10px;
							background: url(../assets/about/icon/p6.png)no-repeat;
							background-size: cover;
							background-position: 100% 0%;
							animation: flash 1000ms infinite both;
						}

						@keyframes flash {

							to {
								width: 70px;
							}

							from {
								width: 25px;
							}
						}

						font-size: 16px;
						color: #00BCD4;
						display: flex;
						align-items: center;
						cursor: pointer;
					}

					p {
						font-size: 14px;
						color: #666666;
						margin-bottom: 15px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					h4 {
						font-size: 24px;
						color: #333333;
						margin-bottom: 20px;
					}

					.time {
						font-size: 24px;
						color: #00BCD4;
						margin: 30px 0 20px;
					}

					width: 532px;
				}

				display: flex;
			}

			height: 290px;
			background-color: #F8F8F8;
			margin-top: 57px;
		}

		.title {
			width: 171px;
			height: 95px;
		}
	}

	.Culture {
		.content {
			.list:hover {
				img {
					transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
					transition: all 0.5s;
				}
			}

			.list {
				div {
					font-size: 16px;
					line-height: 25px;
				}

				p {
					font-size: 14px;
					color: #999999 !important;
					margin-bottom: 12px;
				}

				h5 {
					font-size: 24px;
					margin: 20px 0 5px;
				}

				img {
					width: 80px;
					height: 80px;
				}

				color: #333333;
				text-align: center;
			}

			width: 1050px;
			display: flex;
			justify-content: space-between;
		}

		padding: 19px 0 91px;
		background-color: #FFFFFF;
	}

	.introduce {
		.content {
			.right {
				.p1 {
					margin: 42px 0 39px;
				}

				p {
					font-size: 16px;
					color: #333333;
					line-height: 30px;
				}

				img {
					width: 309px;
					height: 95px;
				}

				width: 485px;
			}

			.left {
				width: 615px;
				height: 399px;
				flex-shrink: 0;
			}

			display: flex;
			justify-content: space-between;
			margin: 60px auto;
		}
	}

	.banner {
		img {
			width: 283px;
			height: 195px;
			margin: 103px 0 0 503px;
		}

		width: 100%;
		height: 400px;
		background: url(../assets/about/icon/p4.png)no-repeat;
		background-size: cover;
		background-position: center center;
		overflow: hidden;
	}

	.searchDiv {
		.on {
			color: #00BCD4 !important;
			font-weight: bold;
			position: relative;
		}

		.on:before {
			content: "";
			display: block;
			position: absolute;
			bottom: -20px;
			left: 50%;
			transform: translate(-50%, 0);
			width: 60px;
			height: 2px;
			background: #00BCD4;
		}

		.screen {
			div:hover {
				color: #00BCD4;
			}

			div {
				cursor: pointer;
			}

			width: 444px;
			font-size: 16px;
			color: #666666;
		}

		/deep/.el-breadcrumb__item .is-link {
			font-weight: 400!important;
		}
		/deep/.el-breadcrumb__inner:hover{
			color: #00BCD4;
		}
		/deep/.el-breadcrumb__inner{
			color: #999999;
		}
		.position {
			font-size: 14px;
			color: #999999;
			display: flex;
			align-items: center;
		}

		position: sticky;
		z-index: 100;
		top: 0;
		width: 100%;
		background-color: #FBFBFB;
		padding: 20px 0;
	}

	.content {
		width: 1200px;
		margin: auto;
	}
</style>
